function RemoveDiacritics() {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 64 64"
          fill="none"
          style={{ direction: "ltr" }} // Prevent flipping in RTL
      >
        <rect width="64" height="64" fill="#FFFFFF" />

        <g style={{ direction: "ltr", unicodeBidi: "plaintext" }}>
          {/* Arabic character "ض" */}
          <text
              x="14"
              y="48"
              fontFamily="Arial, sans-serif"
              fontSize="38"
              fill="currentColor"
              fontWeight="bold"
          >
            ض
          </text>

          {/* Diacritic "َ" */}
          <text
              x="25"
              y="30"
              fontFamily="Arial, sans-serif"
              fontSize="24"
              fill="currentColor"
          >
            َ
          </text>
        </g>

        {/* Diagonal slash line */}
        <line
            x1="55"
            y1="20"
            x2="16"
            y2="60"
            stroke="red"
            strokeWidth="4"
        />
      </svg>
  );
}

export default RemoveDiacritics;
  